import { render, staticRenderFns } from "./customer_coverage.vue?vue&type=template&id=40019577&scoped=true&"
import script from "./customer_coverage.vue?vue&type=script&lang=js&"
export * from "./customer_coverage.vue?vue&type=script&lang=js&"
import style0 from "./customer_coverage.vue?vue&type=style&index=0&id=40019577&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40019577",
  null
  
)

export default component.exports